import { Box } from '@rsos/base-components';
import DataCards from './DataCards';

const DataCardSummary = ({ onDataCardClick = () => {} }) => {
  return (
    <Box width="100%">
      <DataCards summarized onClick={onDataCardClick} />
    </Box>
  );
};

export default DataCardSummary;
